<template>
  <section class="kids-courses">
    <h2 class="section-title">
      Courses
    </h2>
    <p class="section-desc">
      {{ configs.courses && configs.courses.config_value }}
    </p>
    <div class="breadcrumb-container" v-once>
      <Breadcrumb
        :items="breadcrumbLinks"
        icon="chevron-right"
        showActions
        showNote
        note="KidsAssignmentNote"
        color="#5FD068"
      />
    </div>
    <div class="kids-table-info">
      <div class="kids-table-header d-flex">
        <div class="col-6 single-header">
          {{ $t("kidsReservations.users") }}
        </div>
        <div class="col-6 single-header">
          {{ $t("kidsReservations.courses") }}
        </div>
      </div>
      <div class="kids-table-body d-flex" v-for="kid in kids" :key="kid.id">
        <div class="col-6 kid-name d-flex align-items-center">
          {{ kid.first_name }}
        </div>
        <div
          class="col-6 kid-courses d-flex justify-content-between align-items-center"
        >
          {{
            !kid.selected.length
              ? $t("kidsReservations.selectCourse")
              : kid.selected.join(", ")
          }}
          <v-menu offset-y rounded="lg" :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="black">
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(course, index) in courses" :key="course.id">
                <v-checkbox
                  v-model="selectedMatrix[kid.id][index]"
                  :label="course.course.title"
                  color="success"
                  :value="course.id"
                  hide-details
                  @change="
                    selectMatrix(
                      { ...course, course: course.id },
                      kid.id,
                      index
                    )
                  "
                ></v-checkbox>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <template v-if="selfAssign">
        <div class="kids-table-body d-flex">
          <div class="col-6 kid-name d-flex align-items-center">
            {{ $t("kidsReservations.forMyself") }}
          </div>
          <div
            class="col-6 kid-courses d-flex justify-content-between align-items-center"
          >
            {{
              !user.selected.length
                ? $t("kidsReservations.selectCourse")
                : user.selected.join(", ")
            }}
            <v-menu offset-y rounded="lg" :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" color="black">
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(course, index) in courses"
                  :key="course.id"
                >
                  <v-checkbox
                    v-model="selectedMatrix[user.id][index]"
                    :label="course.course.title"
                    color="success"
                    :value="course.id"
                    hide-details
                    @change="
                      selectMatrix(
                        { ...course, course: course.id },
                        course.user,
                        index
                      )
                    "
                  ></v-checkbox>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </template>
      <div class="new-user d-flex flex-column align-items-start">
        <v-checkbox
          v-model="selfAssign"
          :label="$t('kidsReservations.forMyself')"
          color="success"
          hide-details
        />
        <button v-on:click="addKid">
          {{ $t("kidsReservations.addAKid") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import GlobalMixin from "../../GlobalMixin";
import KidsReservationMixin from "../../mixins/KidsReservationMixin";
import Breadcrumb from "../../components/global/Breadcrumb.vue";

export default {
  name: "KidsCoursesView",
  mixins: [GlobalMixin, KidsReservationMixin],
  components: {
    Breadcrumb,
  },
  data() {
    return {
      kids: [],
      courses: [],
      selectedMatrix: {},
      selfAssign: false,
      configs: JSON.parse(localStorage.getItem("configs")),
    };
  },
  /**
   * Initialize Component
   */
  async mounted() {
    // Call Methods when initializing the component
    this.user = { ...this.user, selected: [] };
    this.kids = await this.getKidsDetails();
    this.kids = this.kids.map((k) => ({ ...k, selected: [] }));
    this.kids.forEach((kid) => {
      this.selectedMatrix[kid.id] = [];
    });
    this.selectedMatrix[this.user.id] = [];
    this.courses = this.selectedCourses;
    this.getSelectedMatrices();
    window.addEventListener("localstorageChange", (event) => {
      this.configs = JSON.parse(event.detail.storage.configs);
    });
  },
  destroyed() {
    window.removeEventListener("localstorageChange", () => {});
  },
  methods: {
    /**
     * Dispatch an action to save selected matrix
     * @param course course Object from GET_SELECTED_KIDS_COURSES getter
     * @param id number
     */
    selectMatrix(course, id, index) {
      const course_id = course.course;
      const selectedUser =
        this.user.id === id
          ? this.user
          : false || this.kids.find((k) => k.id === id);
      const selectedCourse = this.courses.find((c) => course_id === c.id);

      if (!this.selectedMatrix[id].includes(course_id)) {
        this.$store.dispatch("removeSelectedMatrix", {
          course: course_id,
          user: id,
        });
        if (
          selectedUser &&
          selectedUser.selected.includes(selectedCourse.course.title)
        ) {
          const index = selectedUser.selected.findIndex(
            (c) => selectedCourse.course.title === c
          );
          selectedUser.selected.splice(index, 1);
        }
        return;
      }

      const matrix = {
        ...course,
        user: id,
        index,
      };
      this.$store.dispatch("saveSelectedMatrix", matrix);

      if (
        selectedUser &&
        !selectedUser.selected.includes(selectedCourse.course.title)
      )
        selectedUser.selected.push(selectedCourse.course.title);
    },

    /**
     * Selected matrcies that already selected in state when component is re-rendered
     * @returns void
     */
    getSelectedMatrices() {
      const matrices = this.$store.getters.GET_SELECTED_MATRIX;
      this.kids = this.kids.map((k) => {
        const courses_id = matrices
          .filter((m) => m.user === k.id)
          .map((c) => c.id);
        const courses = this.courses
          .filter((c) => courses_id.includes(c.id))
          .map((c) => c.course.title);
        k.selected = courses;
        return k;
      });

      const selectedCoursesForUser = matrices.filter(
        (m) => m.user === this.user.id
      );
      if (selectedCoursesForUser.length) {
        this.selfAssign = true;
        const courses_id = matrices
          .filter((m) => m.user === this.user.id)
          .map((c) => c.id);
        const courses = this.courses
          .filter((c) => courses_id.includes(c.id))
          .map((c) => c.course.title);
        this.user.selected = courses;
      }

      matrices.forEach((m) => {
        this.selectedMatrix[m.user][m.index] = m.course;
      });
    },
    /**
     * Fire a custom event to open add kid modal
     * @returns void
     */
    addKid() {
      window.dispatchEvent(
        new CustomEvent("loginModalChange", {
          detail: {
            opened: true,
            tab: 1,
            kidOnly: true,
          },
        })
      );
    },
  },
  computed: {
    /**
     * Get selected courses from Store
     */
    selectedCourses() {
      return this.$store.getters.GET_SELECTED_KIDS_COURSES;
    },
  },
  watch: {
    /**
     * Watch for language change
     */
    async "$i18n.locale"() {
      this.headers.headers["accept-language"] = localStorage.lang;
      this.kids = await this.getKidsDetails();
    },
    /**
     * Remove assigned course for myself when value is false
     * @param newVal Boolean
     */
    selfAssign(newVal) {
      if (!newVal) {
        Object.entries(this.selectedMatrix).filter(([key, value]) => {
          if (key == this.user.id)
            value.forEach((m, index, arr) => {
              this.$store.dispatch("removeSelectedMatrix", m.course);
              arr.splice(index, 1);
            });
        });
      }
    },
  },
};
</script>

<style lang="scss">
:root {
  font-size: 16px;
}

@media all and (max-width: $min-md-screen) {
  :root {
    font-size: 14px;
  }
}
</style>

<style lang="scss" scoped>
.kids-courses {
  max-width: $max-lg-screen;
  font-family: $font-family;
  font-style: normal;
  margin: auto;
  .section-title {
    font-weight: 600;
    font-size: 1.75rem;
    line-height: 2.125rem;
    color: $title;
    margin-bottom: 11px;
  }

  .section-desc {
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    color: $paragraph;
  }
  .breadcrumb-container {
    padding: 16px;
    background: $white;
    border: 1px solid $paragraph;
    border-radius: 8px;
    font-family: $font-family;
    font-style: normal;
    margin-bottom: 25px;
  }

  .kids-table-info {
    border: 1px solid #42526b;
    border-radius: 8px;
    font-family: $font-family;
    font-style: normal;
    background: #e7f5e8;
    margin-bottom: 25px;
    .kids-table-header {
      .single-header {
        padding: 19px 24px;
        font-weight: 500;
        font-size: 1rem;
        line-height: 1.125rem;
        color: #031f05;
      }
    }
    .kids-table-body {
      background: $white;
      .col-6 {
        padding: 10px 24px;
        border-bottom: 1px solid #eaecf0;
      }
      .kid-name {
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 1.25rem;
        color: #101828;
      }
      .kid-courses {
        font-weight: 400;
        font-size: 0.875rem;
        line-height: 1rem;
        color: #667085;
      }
    }
    .new-user {
      padding: 10px 24px;
      background: $white;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      button {
        margin-top: 10px;
        background: $green;
        border-radius: 4px;
        padding: 6px 32px;
        color: $white;
        &:hover {
          background: $hover-green;
        }
      }
    }
  }
}

::v-deep .v-breadcrumbs {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0;
  li {
    padding: 0;
    a {
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
    }
  }
  .v-breadcrumbs__divider {
    .v-icon {
      font-size: 24px;
      color: $black;
    }
  }
}

.v-input--checkbox {
  margin: 0 !important;
}

@media all and (max-width: $max-lg-screen) and (min-width: $min-lg-screen) {
  .kids-courses {
    max-width: $min-lg-screen;
  }
}

@media all and (max-width: $min-lg-screen) and (min-width: $min-md-screen) {
  .kids-courses {
    max-width: $min-md-screen;
  }
}

@media all and (max-width: $min-md-screen) and (min-width: $max-sm-screen) {
  .kids-courses {
    max-width: $max-sm-screen;
  }
}

@media all and (max-width: $max-sm-screen) and (min-width: $min-sm-screen) {
  .kids-courses {
    max-width: $min-sm-screen;
  }
}
</style>
